<template>
  <div class="ct-flex-row">
    <nav class="flex-4 ct-flex-column" v-if="currentSimulation.has_resultat">
        <router-link :to='{ name : "simulation_result_ilot", params : {idExploitation, idSimulation, selected}}' class="icon ilot"></router-link>
        <router-link :to='{ name : "simulation_result_culture", params : {idExploitation, idSimulation, selected}}' class="icon culture"></router-link>
        <router-link :to='{ name : "simulation_result_graph", params : {idExploitation, idSimulation, selected}}' class="icon graph"></router-link>
    </nav>
    <div class="item-flex-full">
      <div v-if="simuClim" class="ct-flex-row items-center flex-end has-tooltip simulation-climatique">
        <span class="mr-5 flex-12" v-tooltip="{ content : getTooltipMessage('simu_clim') }">Simulation climatique</span>
        <v-multiselect
          class="mr-5 flex-30"
          :value="fichier"
          :options="simulations_clims"
          @input="updateSimuClimFichier"
          placeholder="Simulation climatique"
          label="nom"
          track-by="nom"
          :searchable="true"
          :showLabels="false"
          :allow-empty="true"
          :disableda="$store.state.simulation.simuClim.length === 0">
          <template slot="option" slot-scope="props">
            {{props.option.nom}} <em>de {{props.option.annee_min}} à {{props.option.annee_max}}</em>
          </template>
        </v-multiselect>
        <span class="mr-5 flex-12" v-tooltip="{ content : getTooltipMessage('simu_clim_annee') }">Année maximale</span>
        <v-multiselect
          class="mr-5 flex-12"
          :value="annee"
          :options="annees"
          @input="updateSimuClimAnnee"
          placeholder="Année max"
          :searchable="true"
          :showLabels="false"
          :allow-empty="false"
          :disableda="annees.length === 0">
        </v-multiselect>
      </div>

      <div class="ct-flex-row">
        <span v-if="currentSimulation.has_resultat" class="item-flex-full sous-information al-c">{{ $route.meta.breadcrumb.text}}</span>
        <span v-else class="item-flex-full"></span>
        <button class='primary-action mr-5 flex-12 btn-icon lancer' type='button' @click='callEngine'>Appel moteur</button>
        <button class='primary-action mr-5 flex-12 btn-icon synthese' type='button' @click='showDetailSynthese'>Synthèse</button>
        <a class='primary-action mr-5 flex-12 btn-icon exporter' :href="urlDownloadCSV" target="_blank">Export CSV</a>
      </div>

      <div class="sub_zone" v-if="currentSimulation.has_resultat">
        <ResultatFiltre @changed="$refs.subview.loadResult()" class="mb-1"/>
        <router-view :selected='selected' :id-exploitation='idExploitation' :id-simulation='idSimulation' ref="subview"/>
      </div>
      <div v-else class="ct-flex-row justify-center">
        <span class="avertissement">Vous devez faire un appel moteur pour pouvoir afficher les résultats</span>
      </div>
    </div>
    <Dialog :title="'Synthèse ' + synthese.nom + ' (' + synthese.sau + 'ha) - ' + currentSimulation.simulation.nom"
      :show='showSynthese'
      okText='Fermer'
      :cancelText='false'
      @validate="showSynthese=false"
      class="extralarge">
       <synthese :data="synthese" />
    </Dialog>
    <Dialog :title="'Gestion des priotités d\'irrigation'"
      :show='showWarningPriorite'
      okText='Fermer'
      :cancelText='false'
      @validate="showWarningPriorite=false"
    >
      <div>Vous n’avez pas priorisé l’irrigation des cultures de vos parcelles irriguées.</div>
      <div>Cliquez sur « Gérez les priorités » pour choisir l’ordre des cultures qui auront prioritairement accès à l’eau.</div>
    </Dialog>
  </div>
</template>

<script>

import Dialog from '@/components/Dialog'
import Synthese from './Synthese'
import ResultatFiltre from './ResultatFiltre'
import mixinTooltip from '@/mixins/tooltip'

export default {
  name: 'SimulationResultat',
  mixins: [mixinTooltip],

  props: {
    idExploitation: {
      type: String,
      required: true
    },
    idSimulation: {
      type: String,
      required: true
    },
    selected: {
      type: Array,
      required: true
    }
  },

  components: {
    Dialog, Synthese, ResultatFiltre
  },

  data () {
    return {
      selectedIlot: null,
      showSynthese: false,
      showWarningPriorite: false
    }
  },

  computed: {
    currentSimulation () {
      return this.$store.state.simulation.currentSimulation || {}
    },
    synthese () {
      return this.$store.getters.synthese
    },
    token () {
      return this.$store.state.auth.token
    },
    urlDownloadCSV () {
      return `/api/v1/exploitations/${this.idExploitation}/simulations/${this.idSimulation}/download?token=${this.token}`
    },
    simulations_clims () {
      return this.$store.state.simulation.simuClim || []
    },
    fichier () {
      return this.simulations_clims.find(s => s.nom === this.currentSimulation.simulation.fichier_simu_clim)
    },
    annee () {
      return this.currentSimulation.simulation.annee_simu_clim
    },
    annees () {
      if (!this.fichier) {
        return []
      }
      const result = []
      for (let i = this.fichier.annee_min; i <= this.fichier.annee_max; i++) {
        result.push(i)
      }
      return result
    },
    simuClim () {
      return this.$store.state.auth.user.simu_clim
    }
  },

  methods: {
    hasAllPrioritesSet () {
      let mapPrioriteSet = this.selected.map(ilot => ({
        id: ilot,
        ordre: false
      }))
      if (this.currentSimulation.parcelles.length > 0) {
        this.selected.forEach(ilotId => {
          // On test si l'ilot est irrigué ou non
          if (this.$store.getters.ilots.find(el => el.id_ilot === ilotId) && !this.$store.getters.ilots.find(el => el.id_ilot === ilotId).non_irrigue) {
            // On récupère les parcelles de l'ilot nécessitant une priorisation
            let parcellesToOrder = this.currentSimulation.parcelles.filter((p) => p.id_ilot === ilotId && p.dose > 0)

            // S'il n'y a qu'une parcelle, la priorisation est implicite
            if (parcellesToOrder.length <= 1) {
              mapPrioriteSet.find(el => el.id === ilotId).ordre = true
            } else {
              let scenarios = {}

              // On compte les parcelles par scenario
              parcellesToOrder.forEach((p) => {
                if (scenarios[p.id_scenario] === undefined) {
                  scenarios[p.id_scenario] = 0
                }

                // La parcelle est priorisée
                if (p.ordre > 0) {
                  scenarios[p.id_scenario]++
                }
              })

              let sorted = true
              Object.entries(scenarios).forEach(([key, value]) => {
                if (parcellesToOrder.filter((p) => p.id_scenario === key).length > 1 && parcellesToOrder.filter((p) => p.id_scenario === key).length !== value) {
                  sorted = false
                }
              })
              mapPrioriteSet.find(el => el.id === ilotId).ordre = sorted
            }
          } else {
            mapPrioriteSet.find(el => el.id === ilotId).ordre = true
          }
        })
      }
      return mapPrioriteSet.find(el => el.ordre === false) === null || mapPrioriteSet.find(el => el.ordre === false) === undefined
    },
    callEngine () {
      // On test si les priorités d'irrigation ont été gérées
      if (this.hasAllPrioritesSet()) {
        this.$store.dispatch('calculSimulation')
          .then(() => {
            this.$refs.subview.loadResult()
          }).finally(() => {
            this.$store.commit('DEL_LOADING_MESSAGES')
          })
      } else {
        this.showWarningPriorite = true
      }
    },

    updateSimuClimFichier (fichier) {
      this.$store.commit('UPDATE_SIMULATION_CLIMATIQUE', {
        fichier: fichier && fichier.nom,
        annee: fichier && Math.max(Math.min(this.annee || 9999, fichier.annee_max), fichier.annee_min)
      })
    },

    updateSimuClimAnnee (annee) {
      this.$store.commit('UPDATE_SIMULATION_CLIMATIQUE', {
        fichier: this.fichier.nom,
        annee: annee
      })
    },

    showDetailSynthese () {
      this.showSynthese = true
    }
  }
}
</script>
